import { Button } from "../../../../components/buttons/button";
import { EventImage } from "../../../../components/event/eventImage";
import { Icon } from "../../../../components/icon/icon";
import { Pill } from "../../../../components/pill";
import { BgWrapper } from "../../../../components/wrapper/bgWrapper";
import { CreatedEvent } from "../../../../redux/features/event/event.types";
import {
  formatDate,
  formatTime,
  getEventUrl,
  handleShare,
  parseTimeToDate,
} from "../../../../utils/helpers";

type UserSalesCardProps = {
  event?: CreatedEvent;
};

export const UserSalesCard = ({ event }: UserSalesCardProps) => {
  return (
    <BgWrapper className="flex cursor-pointer flex-col gap-8 md:flex-row md:flex-wrap md:items-center">
      <EventImage image={event?.image} dimension={300} className={""} />
      <div className="flex w-full flex-col justify-center gap-4 md:min-h-[300px] md:min-w-[350px] md:flex-1 xl:!min-h-full xl:w-fit">
        <Pill
          className=""
          text={event?.status === "upcoming" ? "UPCOMING" : "DRAFT"}
          variation={event?.status === "upcoming" ? "blue" : "grey"}
        />
        <div className="flex flex-col gap-2">
          <p
            className={"text-32 flex flex-col gap-1 font-fraunces font-medium"}
          >
            {event?.name}
            <span className="font-fustat text-sm font-normal tracking-normal text-grey-900">
              Created On{" "}
              {formatDate(event?.createdBy?.createdAt, "MMMM DD, YYYY")}
            </span>
          </p>
          <p className="mt-2 flex items-center gap-2">
            <Icon
              svg="map-pin"
              width={20}
              height={20}
              className="min-w-fit text-grey-500"
            />
            <span className="font-fustat text-sm font-normal tracking-normal text-grey-900">
              {event?.location}
            </span>
          </p>
          <p className="flex items-center gap-2">
            <Icon
              svg="calendar"
              width={20}
              height={20}
              className="mb-1 min-w-fit text-grey-500"
            />
            <span className="font-fustat text-sm font-normal tracking-normal text-grey-900">
              {formatDate(event?.startDate, "dddd, MMMM DD, YYYY")}
            </span>
          </p>
          <p className="flex items-center gap-2">
            <Icon
              svg="clock"
              width={20}
              height={20}
              className="mb-1 min-w-fit text-grey-500"
            />
            <span className="font-fustat text-sm font-normal tracking-normal text-grey-900">
              {formatTime(parseTimeToDate(event?.startTime ?? ""))} -{" "}
              {formatTime(parseTimeToDate(event?.endTime ?? ""))}
            </span>
          </p>
          <p className="flex items-center gap-2">
            <Icon
              svg="user"
              width={20}
              height={20}
              className="mb-1 min-w-fit text-grey-500"
            />
            <span className="font-fustat text-sm font-normal tracking-normal text-grey-900">
              {event?.createdBy?.firstName} {event?.createdBy?.lastName}
            </span>
          </p>
          <div className="flex w-full items-center gap-2.5">
            <Button
              type="button"
              // onClick={() => {
              //   window.open(getEventUrl(event?.slug!), "_blank");
              // }}
              onClick={async () => {
                await handleShare("", "", getEventUrl(event?.slug ?? ""));
              }}
              text="Share Event"
              icon="share-two"
              variation="plain-grey"
              className=""
              disabled={false}
            />
            <Button
              type="button"
              onClick={() => {
                window.open(getEventUrl(event?.slug!), "_blank");
              }}
              text="Go To Event"
              icon="share"
              variation="plain-grey"
              className=""
              disabled={false}
            />
          </div>
        </div>
      </div>
    </BgWrapper>
  );
};
